import { ProductTooltipRuntime } from "./core/engine";
import { maybeAutoInitFromScript } from "./auto-init";
import type { TooltipConfig, TooltipEngine } from "./types";

export type {
  EngineStats,
  KeywordRule,
  MatchEvent,
  MatchContext,
  MatchRule,
  ProductData,
  RegexRule,
  RulesPayload,
  RulesSource,
  TooltipConfig,
  TooltipEngine,
  TooltipThemeVars
} from "./types";

export function initProductTooltip(config: TooltipConfig): TooltipEngine {
  return new ProductTooltipRuntime(config);
}

const ProductTooltip = {
  initProductTooltip
};

declare global {
  interface Window {
    ProductTooltip?: typeof ProductTooltip;
  }
}

if (typeof window !== "undefined") {
  window.ProductTooltip = ProductTooltip;
  maybeAutoInitFromScript(initProductTooltip);
}

export default ProductTooltip;
